(function () {
  'use strict';

  function initV13Logic() {
    var root = document.querySelector('.right-column-v13');
    if (!root) return;
    if (root.getAttribute('data-ml353-bound') === '1') return;
    root.setAttribute('data-ml353-bound', '1');

    if (/(?:^|[?&])v13=1(?:&|$)/.test(window.location.search || '')) {
      var v6Col = document.querySelector('.right-column-v6');
      if (v6Col) v6Col.style.setProperty('display', 'none', 'important');
      root.style.setProperty('display', 'block', 'important');
    }

    var cards = root.querySelectorAll('.v13-plan-card');
    var ctaBtn = document.getElementById('v13-add-to-cart');
    var ctaText = root.querySelector('.v13-cta-text');
    var duePrice = root.querySelector('.v13-due-price');
    var ctaTemplate = root.getAttribute('data-cta-template') || 'Order for %price%';

    function selectedCard() {
      return root.querySelector('.v13-plan-card.is-active') || cards[0] || null;
    }

    function updateSummary() {
      var card = selectedCard();
      if (!card) return;
      var radio = card.querySelector('.v13-hidden-radio');
      var price = card.getAttribute('data-due-price') || '';
      if (ctaBtn) ctaBtn.href = (radio && radio.getAttribute('data-url')) || '#';
      if (duePrice) duePrice.textContent = price;
      if (ctaText) ctaText.textContent = ctaTemplate.split('%price%').join(price);
    }

    function selectCard(card) {
      cards.forEach(function (item) {
        item.classList.remove('is-active');
        var radio = item.querySelector('.v13-hidden-radio');
        if (radio) radio.checked = false;
      });
      if (!card) return;
      card.classList.add('is-active');
      var radio = card.querySelector('.v13-hidden-radio');
      if (radio) radio.checked = true;
      updateSummary();
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectCard(card);
      });
    });

    selectCard(root.querySelector('.v13-plan-card.is-active') || cards[0]);
  }

  window.initV13Logic = initV13Logic;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initV13Logic);
  } else {
    initV13Logic();
  }
})();
